/**
 * OIMS v2 - Theme management
 * Dark/light toggle with OS preference detection
 */

export function initTheme() {
  const stored = localStorage.getItem('oims-theme');
  const theme = stored || (window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark');
  document.documentElement.setAttribute('data-bs-theme', theme);
  updateThemeToggleIcon();
}

export function toggleTheme() {
  const current = document.documentElement.getAttribute('data-bs-theme');
  const next = current === 'dark' ? 'light' : 'dark';
  document.documentElement.setAttribute('data-bs-theme', next);
  localStorage.setItem('oims-theme', next);
  updateThemeToggleIcon();
}

export function updateThemeToggleIcon() {
  const btn = document.getElementById('btnThemeToggle');
  if (!btn) return;
  const icon = btn.querySelector('i');
  if (!icon) return;
  const isDark = document.documentElement.getAttribute('data-bs-theme') === 'dark';
  icon.className = isDark ? 'bi bi-moon-fill' : 'bi bi-sun-fill';
  btn.title = isDark ? 'Switch to light mode' : 'Switch to dark mode';
}

// Listen for OS-level color scheme changes
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
  if (!localStorage.getItem('oims-theme')) {
    const theme = e.matches ? 'dark' : 'light';
    document.documentElement.setAttribute('data-bs-theme', theme);
    updateThemeToggleIcon();
  }
});
